import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { LogoMake } from 'Storybook/components/local/LogoMake/LogoMake';

import type { Brand } from '../../../../client/index.helper';

export const Makes = ({ makes = [] }: {makes: Brand[] }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const [loadImages, setLoadImages] = useState(false);
  const [webpSupport, setWebpSupport] = useState(true);

  useEffect(() => {
    if ('IntersectionObserver' in window) {
      const options = {
        rootMargin: '400px',
        threshold: 0,
      };

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setLoadImages(true);
          setWebpSupport(true);
          observerRef.current?.disconnect();
        }
      }, options);

      if (containerRef.current) {
        observerRef.current.observe(containerRef.current);
      }
    } else {
      setLoadImages(true);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div ref={containerRef} className={'menuMakes'}>
      <ul>
        {makes.map(({ display_name: name, id, slug }) => (
          <li key={id}>
            <LogoMake
              className={'mw-i'}
              element={Link}
              make={loadImages ? slug : ''}
              title={name}
              to={`/sell-my-car/brands/${slug}`}
              webp={webpSupport}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
